(()=>{
  const cfgEl=document.getElementById('DoreHomeConfig');
  let cfg={};try{cfg=JSON.parse(cfgEl?.textContent||'{}')}catch(e){cfg={}}
  const localeRoot=(()=>{const r=String(window.Shopify?.routes?.root||'/');return r.endsWith('/')?r:r+'/';})();

  document.querySelectorAll('[data-dh-compare]').forEach(section=>{
    section.classList.add('is-ready');
    const reveal=()=>section.classList.add('is-visible');
    if(!('IntersectionObserver' in window)){reveal();return}
    const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){reveal();observer.disconnect()}})},{threshold:.2});
    observer.observe(section);
  });

  const slider=document.querySelector('[data-home-slider]');
  const slides=[...document.querySelectorAll('[data-slide]')];
  const lines=[...document.querySelectorAll('[data-slide-line]')];
  let active=0,timer;
  const cssUrl=u=>'url("'+String(u||'').replace(/"/g,'%22')+'")';
  function hydrateSlide(slide){
    if(!slide||slide.dataset.slideLoaded==='1')return;
    if(slide.dataset.slideDesktop)slide.style.setProperty('--slide',cssUrl(slide.dataset.slideDesktop));
    if(slide.dataset.slideMobile)slide.style.setProperty('--slide-mobile',cssUrl(slide.dataset.slideMobile));
    slide.dataset.slideLoaded='1';
  }
  hydrateSlide(slides[0]);
  const hydrateRemaining=()=>slides.slice(1).forEach(hydrateSlide);
  const schedule=()=>{clearTimeout(timer);timer=setTimeout(()=>show(active+1),6500)};
  function show(i){
    if(!slides.length)return;
    active=(i+slides.length)%slides.length;hydrateSlide(slides[active]);
    slides.forEach((s,n)=>s.classList.toggle('is-active',n===active));
    lines.forEach((d,n)=>d.classList.toggle('is-active',n===active));schedule();
  }
  document.querySelector('[data-slide-prev]')?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();show(active-1)});
  document.querySelector('[data-slide-next]')?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();show(active+1)});
  lines.forEach(d=>d.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();show(Number(d.dataset.slideLine))}));
  const startSlider=()=>{
    slider?.classList.add('is-ready');
    if('requestIdleCallback' in window)requestIdleCallback(hydrateRemaining,{timeout:2200});else setTimeout(hydrateRemaining,900);
    schedule();
  };
  if(document.readyState==='complete')startSlider();else window.addEventListener('load',startSlider,{once:true});

  let bundleReady=false;
  function initBundle(){
    if(bundleReady)return;bundleReady=true;
    const modal=document.querySelector('[data-bundle-modal]');
    const countEl=document.querySelector('[data-bundle-count]');
    const selectedTotalEl=document.querySelector('[data-bundle-selected-total]');
    const selectedEl=document.querySelector('[data-bundle-selected]');
    const modalPriceEl=document.querySelector('[data-bundle-modal-price]');
    const modalSaveEl=document.querySelector('[data-bundle-modal-save]');
    const addBundleBtn=document.querySelector('[data-bundle-add]');
    let bundleSize=3;
    const choices=[...document.querySelectorAll('.dh-bundle-choice input')];
    const bundleMeta={2:{price:'CHF 92.90',save:'CHF 13.90'},3:{price:'CHF 129.90',save:'CHF 26.80'},4:{price:'CHF 164.90',save:'CHF 41.70'}};
    function syncBundle(){
      const checked=choices.filter(x=>x.checked);
      choices.forEach(x=>x.closest('label').classList.toggle('is-selected',x.checked));
      if(countEl)countEl.textContent=bundleSize;if(selectedTotalEl)selectedTotalEl.textContent=bundleSize;if(selectedEl)selectedEl.textContent=checked.length;
      if(modalPriceEl)modalPriceEl.textContent=bundleMeta[bundleSize]?.price||'';if(modalSaveEl)modalSaveEl.textContent=bundleMeta[bundleSize]?.save||'';
      if(addBundleBtn)addBundleBtn.disabled=checked.length!==bundleSize;
    }
    function openBundle(size,handles=[]){
      bundleSize=Number(size)||3;const wanted=new Set(handles.filter(Boolean));choices.forEach(x=>{x.checked=wanted.has(x.dataset.handle)});
      syncBundle();modal?.classList.add('is-open');modal?.setAttribute('aria-hidden','false');
    }
    document.querySelectorAll('.dh-bundle-tier[data-bundle-size]').forEach(b=>b.addEventListener('click',()=>openBundle(b.dataset.bundleSize)));
    document.querySelectorAll('[data-bundle-suggestion]').forEach(b=>b.addEventListener('click',()=>openBundle(b.dataset.bundleSize,(b.dataset.bundleSuggestion||'').split(','))));
    document.querySelector('[data-bundle-close]')?.addEventListener('click',()=>{modal?.classList.remove('is-open');modal?.setAttribute('aria-hidden','true')});
    modal?.addEventListener('click',e=>{if(e.target===modal){modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true')}});
    choices.forEach(ch=>ch.addEventListener('change',()=>{
      const checked=choices.filter(x=>x.checked);
      if(checked.length>bundleSize){ch.checked=false;window.DoreCart?.toast(cfg.bundleErrorPrefix+' '+bundleSize+' '+cfg.bundleErrorSuffix)}
      syncBundle();
    }));
    addBundleBtn?.addEventListener('click',async()=>{
      const selected=choices.filter(x=>x.checked);
      if(selected.length!==bundleSize){window.DoreCart?.toast(cfg.bundleErrorPrefix+' '+bundleSize+' '+cfg.bundleErrorSuffix);return}
      try{
        await fetch(localeRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:selected.map(x=>({id:Number(x.value),quantity:1}))})});
        modal?.classList.remove('is-open');modal?.setAttribute('aria-hidden','true');window.DoreCart?.render(true);
      }catch(e){window.DoreCart?.toast(cfg.bundleErrorAdd)}
    });
    syncBundle();
  }
  const bundleSection=document.getElementById('bundles');
  if(bundleSection&&'IntersectionObserver' in window){
    const bio=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){initBundle();bio.disconnect()}},{rootMargin:'550px 0px',threshold:0});
    bio.observe(bundleSection);
  }else if(bundleSection){
    if('requestIdleCallback' in window)requestIdleCallback(initBundle,{timeout:2500});else setTimeout(initBundle,1200);
  }
  document.addEventListener('pointerdown',e=>{if(!bundleReady&&e.target.closest('.dh-bundle-tier[data-bundle-size],[data-bundle-suggestion]'))initBundle()},{capture:true,passive:true});

  const stacks=[...document.querySelectorAll('[data-bundle-rotate]')];
  const reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const setPositions=(stack,offset=0)=>{const imgs=[...stack.querySelectorAll('img')],n=imgs.length;if(!n)return;imgs.forEach((img,i)=>img.dataset.stackPos=String((i-offset+n)%n))};
  stacks.forEach((stack,index)=>{
    let offset=0,timerId=0,visible=false;const delay=2800+(index*420);setPositions(stack,offset);
    if(reduce||stack.querySelectorAll('img').length<2)return;
    const stop=()=>{if(timerId){clearTimeout(timerId);timerId=0}};
    const scheduleRotation=()=>{
      if(timerId||!visible||document.hidden)return;
      timerId=setTimeout(()=>{timerId=0;if(!visible||document.hidden)return;const n=stack.querySelectorAll('img').length;offset=(offset+1)%n;setPositions(stack,offset);scheduleRotation()},delay);
    };
    if('IntersectionObserver' in window){
      const io=new IntersectionObserver(entries=>{visible=entries.some(e=>e.isIntersecting);if(visible)scheduleRotation();else stop()},{rootMargin:'150px 0px',threshold:0});
      io.observe(stack);
    }else{visible=true;scheduleRotation()}
    document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();else scheduleRotation()});
  });
})();